import React, {} from "react";
import "./Contact.css";
import { Button, Input, Form, Select, } from "antd";
import { SelectDaysOptions, SelectTimeOptions } from "../../../constOptions/constOptions";

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
    required: "${label} is required!",
    types: {
        email: "${label} is not a valid email!",
        number: "${label} is not a valid number!",
    },
    number: {
        range: "${label} must be between ${min} and ${max}",
    }
};
/* eslint-enable no-template-curly-in-string */

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

export const Contact = () => {
    const onFormFinish = (values) => {
        console.log('Success:', values);
      };
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
    return(
        <>
        <div className="ground-color-ashes">
            <section className="sector-contact-form">
                <div className="mtp-container">
                    <div className="sector-contact-form-container">
                        <div className="sector-contact-form-header flex-center flex-column">
                            <h3 className="fw-700 text-color-alpha" >Contact Us</h3>
                            <span className="fw-400 text-color-bravo" >Have questions? We are here to help.</span>
                        </div>
                        <div className="sector-contact-form-wrapper">
                        <Form
                            layout="vertical"
                            autoComplete="off"
                            initialValues={{ remember: true, }}
                            onFinish={onFormFinish}
                            onFinishFailed={onFinishFailed}
                            validateMessages={validateMessages}>
                            
                            <span className="contact-form-title fw-600">Fill This Information To Contact Us</span>

                            <div className="contact-form-wrap">
                                <Form.Item name="Name" label="Name" rules={[{ required: true, message: "This field can not be empty!", },]}>
                                    <Input placeholder="Ex. abc" className="mtp-form-control" />
                                </Form.Item>
                                <Form.Item name="Organisation Name" label="Organisation Name" >
                                    <Input placeholder="Ex. abc" className="mtp-form-control" />
                                </Form.Item>
                            </div>

                            <div className="contact-form-wrap">
                                <Form.Item name="Email" label="Email" rules={[{ type: "email", required: true, }]}>
                                    <Input placeholder="Ex. www.xyz.com" className="mtp-form-control" />
                                </Form.Item>

                                <Form.Item name="phone" label="Preferred Phone No" rules={[{ type:"number", required: true, message: 'Please input your phone number!'}]}>
                                    <Input placeholder="Ex. +1 (250) 124 2365" className="mtp-form-control" />
                                </Form.Item>
                            </div>

                            <div className="contact-form-wrap third-contact-form-wrap">
                                <Form.Item name="Time to Contact" label="Time to Contact" rules={[{ required: true, message: 'Please input your time to contact!', }]}>
                                    <Input placeholder="Ex. Monday after 3PM" className="mtp-form-control" maxLength={5}/>
                                </Form.Item>

                                <span className="d-inline-flex align-center justify-center">OR</span>

                                <Form.Item name="Best Time Window to Contact" label="Best Time Window to Contact" >
                                    <Select className="mtp-select-control" placeholder="Afternoon" defaultValue="Afternoon" onChange={handleChange} options={SelectTimeOptions} />
                                </Form.Item>

                                <Form.Item name="Best Days to Contact" label="Best Days to Contact" >
                                    <Select className="mtp-select-control" placeholder="Monday - Friday" defaultValue="Monday - Friday" onChange={handleChange} options={SelectDaysOptions} />
                                </Form.Item>
                            </div>

                            <Form.Item className="mb-0 text-center">
                                <Button className="ant-btn ant-btn-default mtp-button button-alpha" htmlType="submit"> Contact </Button>
                            </Form.Item>
                        </Form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        </>
    )
}